/*
 * @Author       : 萝卜兄台
 * @Date         : 2023-03-01 13:34:24
 * @LastEditors  : 萝卜兄台\thund leili995997651@qq.com
 * @LastEditTime : 2024-04-01 18:00:33
 * @FilePath     : \gray-fabric-defect-management-frontend\src\utils\constants.ts
 * @Description  : api 配置
 */

let ApiUrl: string = import.meta.env?.VITE_APP_ApiUrl || ''
let ApiDyjUrl: string = import.meta.env?.VITE_APP_ApiDyjUrl || ''
let ApiImage: string = import.meta.env?.VITE_APP_ApiImage || ''




// const ip: string = window.location.hostname

// let ApiUrl: string = `http://${ip}:10002/api`
// let ApiDyjUrl: string = `http://${ip}:10006/api`
// let ApiImage: string = `http://${ip}:9000/`
export default {
    ApiUrl,
    ApiImage,
    ApiDyjUrl
}
